import { createFileRoute, notFound } from '@tanstack/react-router';
import { ArticlePath, createGuideLink, RouteName, TextKey } from '@mews-commander/enums';
import {
    canCurrentProfileManageEnterpriseEmployees,
    isCurrentEnterprisePortfolio,
} from '@mews-commander/legacy-entities';
import {
    EnterpriseType,
    MultiPropertyUsers,
    UserDetailContextProvider,
    UsersContextProvider,
    UserType,
} from '@mews-commander/modules/src/modules/userManagement';
import { DialogProvider } from '@mews-commander/ui';
import { MewsTeam, RouteType } from '@mews/enums';

export const Route = createFileRoute(
    '/_authenticated/$currentEnterpriseId/UserManagement/MultiProperty/PropertyUsers/Index/'
)({
    beforeLoad: ({ context: { getState__DO_NOT_USE_OR_YOU_WILL_BE_FIRED: getState } }) => {
        const state = getState();
        const check = isCurrentEnterprisePortfolio(state) && canCurrentProfileManageEnterpriseEmployees(state);

        if (!check) {
            throw notFound();
        }
    },
    component: Component,
    staticData: {
        title: TextKey.PropertyUsers,
        routeName: RouteName.UserManagementMultiPropertyPropertyUsersIndex,
        owner: MewsTeam.Users,
        type: RouteType.Frontend,
    },
});

function Component() {
    const guideLink = createGuideLink(ArticlePath.SetUpAndCustomizeUsersMultiProperty);

    return (
        <UsersContextProvider userType={UserType.Properties} enterpriseType={EnterpriseType.Portfolio}>
            <UserDetailContextProvider>
                <DialogProvider>
                    <MultiPropertyUsers activeTab={TextKey.PropertyUsers} guideLink={guideLink} />
                </DialogProvider>
            </UserDetailContextProvider>
        </UsersContextProvider>
    );
}
